import StoredLayout from '../../layouts/StoredLayout'
import Faq from './Faq'
export default StoredLayout(Faq)
